import { render, staticRenderFns } from "./McnTaskFollowRecord.vue?vue&type=template&id=760dada4&scoped=true"
import script from "./McnTaskFollowRecord.vue?vue&type=script&lang=js"
export * from "./McnTaskFollowRecord.vue?vue&type=script&lang=js"
import style0 from "./McnTaskFollowRecord.vue?vue&type=style&index=0&id=760dada4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760dada4",
  null
  
)

export default component.exports